import type { DefaultOptionType } from 'antd/es/select';

export function normalizeSearchText(value: string): string {
  return value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
}

export function filterOptionByLabel(input: string, option?: DefaultOptionType): boolean {
  return normalizeSearchText(String(option?.label ?? '')).includes(normalizeSearchText(input));
}
